import { IgniteResponse } from '@clubhub/ignite/models/ignite-response';

export interface AffordabilityLenders {
  lenderName: string;
  lenderLogoUrl: string;
}
export class AffordabilityPollResponse {
  public pollJobID: number | null = null;
  public affordabilitySearchId: string | null = null;
  public quotes: IgniteResponse[] = [];
  public errorMessage: string | null = null;
  public completed: boolean = false;

  /** Will only have a value on the initial request to the server, not subsequent poll requests. */
  public lenderCount: number = 0;
  /** Will only have a value on the initial request to the server, not subsequent poll requests. */
  public lenders?: AffordabilityLenders[];

  public static response(lender: AffordabilityLenders): IgniteResponse {
    return {
      affordabilitySearchId: null,
      source: null,
      lenderName: lender.lenderName,
      lenderLogoUrl: lender.lenderLogoUrl,
      affordabilityOffReason: null,
      maximumLoanAmount: null,
      maximumLoanAmounts: null,
      minimumRentalNeededAmounts: null,
      maximumAffordableLoanAmount: null,
      maximumValue: null,
      affordabilityResult: null,
      quoteNumber: null,
      error: {
        statusCode: '102',
        message: 'Not Completed',
      },
      httpError: null,
      httpErrorMessage: null,
      tooManyApplicants: null,
      limitToTwoIncomes: null,
      payrate: null,
      stressRate: null,
      expanded: false,
      icr: null,
    };
  }
}
